export const getSkinTypeValue = (code: string): string => {
  if (code === '1') {
    return 'oily';
  } else if (code === '2') {
    return 'combination-oily';
  } else if (code === '3') {
    return 'combination-dry';
  }
  else {
    return 'dry';
  }
};